import { HTTP } from '../../http-common'

export default {
  state: {
    loadedAirInlets: []
  },
  getters: {
    loadedAirInlets (state) {
      return state.loadedAirInlets
    }
  },
  mutations: {
    setLoadedAirInlets (state, payload) {
      state.loadedAirInlets = payload
    },
    createAirInlet (state, payload) {
      state.loadedAirInlets.push(payload)
    },
    updateAirInlet (state, payload) {
      state.loadedAirInlets = state.loadedAirInlets.map(airInlet => airInlet.id === payload.id ? payload : airInlet)
    },
    removeAirInlet (state, id) {
      state.loadedAirInlets = state.loadedAirInlets.filter(airInlet => {
        return airInlet.id !== id
      })
    },
    clearLoadedAirInlets (state) {
      state.loadedAirInlets = []
    }
  },
  actions: {
    loadAirInlets ({ commit }) {
      commit('clearError')
      commit('setLoading', true)
      commit('setLoadedAirInlets', [])

      return new Promise((resolve, reject) => {
        HTTP.get('air_inlet_type.json')
          .then(result => {
            console.log(result.data)
            commit('setLoadedAirInlets', result.data.results)
            resolve(result.data)
          })
          .catch(err => {
            console.log(err)
            commit('setError', err)
            reject(err)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    },
    createAirInlet ({ commit, getters }, payload) {
      console.log('createAirInlet')
      commit('clearError')
      commit('setLoading', true)
      const newAirInlet = {
        description: payload.description
      }
      return new Promise((resolve, reject) => {
        HTTP.post('air_inlet_type.json/', newAirInlet)
          .then(result => {
            console.log(result)
            commit('createAirInlet', result.data)
            resolve(result)
          })
          .catch(err => {
            console.log(err)
            commit('setError', err)
            reject(err)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    },
    updateAirInlet ({ commit, getters }, payload) {
      console.log('updateAirInlet')
      commit('clearError')
      commit('setLoading', true)
      const airInlet = {
        description: payload.description
      }
      return new Promise((resolve, reject) => {
        HTTP.patch(`air_inlet_type.json/${payload.id}/`, airInlet)
          .then(result => {
            console.log(result)
            commit('updateAirInlet', result.data)
            resolve(result)
          })
          .catch(err => {
            console.log(err)
            commit('setError', err)
            reject(err)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    },
    removeAirInlet ({ commit }, payload) {
      console.log('removeAirInlet')
      commit('clearError')
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        HTTP.delete(`air_inlet_type.json/${payload}`)
          .then(result => {
            console.log('result', result)
            commit('removeAirInlet', payload)
            resolve(result)
          })
          .catch(err => {
            console.log(err)
            commit('setError', err)
            reject(err)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    },
    clearLoadedAirInlets ({ commit }) {
      commit('clearLoadedAirInlets')
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/air_inlet/index.js